import moment from "moment-timezone";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiResponse } from "../../../api/apiResponse";
import { updateCandidateQualification } from "../../../api/endpoints/tutors/candidates";
import { updateTutorSession } from "../../../api/endpoints/tutors/sessions";
import SessionModel from "../../../api/models/SessionModel";
import { makeApiRequest } from "../../../helpers";
import AppButton from "../../buttons/AppButton";
import Modal from "../ModalWithFooter";
import useTimeout from "../../../hooks/useTimeout";
import toast from "react-hot-toast";

type EndCandidateSessionProps = {
  isOpen: boolean;
  onClose: () => void;
  session: SessionModel;
  onEndSession: () => void;
};
export default function EndCandidateSession(props: EndCandidateSessionProps) {
  const { isOpen, onClose: onCloseModal, session, onEndSession } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.tutor.dashboard.room",
  });
  const now = moment();
  const remainingTime =
    (18 + session?.start_time!.diff(now, "minutes")) * 60 * 1000;
  const [isQualified, setIsQualified] = useState<boolean | undefined>();
  const [pages, setPages] = useState<string | number | undefined>();

  const onClose = () => {
    setIsQualified(undefined);
    setPages(0);
    onCloseModal();
  };
  const updateSessionStatus = async () => {
    await makeApiRequest(
      () =>
        updateTutorSession(session.id, {
          end_time: moment(),
          reported_status: "completed",
        }),
      (response: ApiResponse) => {
        onEndSession();
        onClose();
      }
    );
  };

  const updateQualifiedStatus = async () => {
    await makeApiRequest(
      () =>
        updateCandidateQualification(
          session.student?.id!,
          !!isQualified,
          pages ?? 1
        ),
      (response: ApiResponse) => {
        updateSessionStatus();
      }
    );
  };
  useTimeout(() => {
    updateQualifiedStatus();
  }, remainingTime);

  return (
    <Modal open={isOpen} setOpen={onClose}>
      <Modal.Body setOpen={onClose} title={t("endSession")}>
        <div className="flex flex-col gap-1">
          <p className="text-sm font-medium text-gray-700">
            {t("isCandidateQualified")}
          </p>
          <div className="flex gap-8 py-[9px]">
            <div className="flex items-center gap-2">
              <input
                id="qualified"
                name="notification-method"
                type="radio"
                checked={isQualified === true}
                onChange={() => setIsQualified(true)}
                className="h-4 w-4 border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
              />
              <label
                htmlFor="qualified"
                className="block text-sm font-medium text-gray-700"
              >
                {t("yes")}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                id="not-qualified"
                name="notification-method"
                type="radio"
                checked={isQualified === false}
                onChange={() => setIsQualified(false)}
                className="h-4 w-4 border-gray-300 text-brandblue-600 focus:ring-brandblue-500"
              />
              <label
                htmlFor="not-qualified"
                className="block text-sm font-medium text-gray-700"
              >
                {t("notYet")}
              </label>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 mt-4">
          <p className="text-sm font-medium text-gray-700">
            {t("readPages") + " *"}
          </p>
          <div className="flex gap-8 ">
            <div className="flex items-center gap-2 w-full mt-4">
              <input
                type="number"
                onChange={(e) => setPages(e.target.value)}
                className="  rtl:pl-10 ltr:pr-10 text-sm  shadow-sm focus:ring-brandblue-500 focus:border-brandblue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                placeholder={t("pageTo")}
                name="pageTo"
                id="pageTo"
                required
                min="1"
                max="604"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-4 px-2">
          <AppButton buttonShape="secondary" onClick={onClose}>
            {t("cancel")}
          </AppButton>
          <AppButton
            buttonShape="primary-danger"
            onClick={updateQualifiedStatus}
            disabled={isQualified === undefined || !pages}
          >
            {t("endSession")}
          </AppButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
